module.exports = __webpack_public_path__ + "img/icon3.8f6fada6.jpg";